import {ValidationError} from "./validation";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
    return emailRegex.test(value.trim());
}

export function getEmailValidationError(value: string, isEmailRequired: boolean): ValidationError | null {
    if (!value.trim()) {
        return null;
    }

    if (!isEmailRequired && value.length < 6) {
        return {key: "usernameValidation.invalid"};
    }

    if (isEmailRequired && !isValidEmail(value)) {
        return {key: "emailValidation.invalid"};
    }

    return null;
}
